import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["fallback", "surveyId", "surveyType"];
import FeedbackSurveyModalContent from './FeedbackSurveyModalContent';
import useFeedbackSurveyConfig from '../hooks/useFeedbackSurveyConfig';
import { jsx as _jsx } from "react/jsx-runtime";
const FeedbackSurveyModal = _ref => {
  let {
      fallback,
      surveyId,
      surveyType
    } = _ref,
    modalContentProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    loading,
    surveyConfig,
    setSurveyConfig
  } = useFeedbackSurveyConfig({
    surveyId,
    surveyType
  });
  if (loading) {
    return null;
  }
  if (!(surveyConfig !== null && surveyConfig !== void 0 && surveyConfig.config)) {
    return fallback || null;
  }
  return /*#__PURE__*/_jsx(FeedbackSurveyModalContent, Object.assign({}, modalContentProps, {
    surveyConfig: surveyConfig,
    surveyId: surveyId,
    onClose: () => {
      setSurveyConfig(null);
    }
  }));
};
export default FeedbackSurveyModal;